<div class="animate__animated animate__slideInUp">
    <mat-card>
        <app-lista-doctransferencias></app-lista-doctransferencias>
    </mat-card>
</div>